import { lazy } from 'react';
export const System = lazy(() => import('@/Portal/System/SystemTabs'));
export const StagedShoppers = lazy(() => import('@/TraderPortal/StagedShoppers'));
export const Leads = lazy(() => import('@/Sales/SalesLeadsList'));
export const LeadForm = lazy(() => import('@/Sales/LeadForm'));
export const DCRMSupportTool = lazy(() => import('@/Portal/DynamicsCRM/DCRMSupportTool'));
export const Samples = lazy(() => import('@/Samples/Samples'));
